module.exports = "/call-frontend/img/menu_bar_bg_light.3694aa80.png";